<footer class="footer" [class.footer-auth]="isAuth()">

  <div class="container-fluid">
    <div class="copyright" id="copyright">
      &copy; {{ today() | date: "yyyy" }}, Designed by
      <a href="https://www.dotitsrl.it/">Dotit</a>. Coded
      by
      <a href="https://www.dotitsrl.it/" target="_blank">Dotit</a>.
    </div>
  </div>
</footer>
